import {NgTemplateOutlet} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {BoardGroupModel, BoardTableModel} from '../../../models/tasktable.model';
import {MemberModel} from '../../../models/user.model';
import {TaskServiceService} from '../../../services/task-service.service';
import {ComponentsModule} from '../../components.module';
import {TaskDashboardsV2Component} from '../../task-dashboards/task-dashboards-v2/task-dashboards-v2.component';

@Component({
    selector: 'app-business-process-index-tab',
    standalone: true,
    imports: [
        TaskDashboardsV2Component,
        TranslatePipe,
        ComponentsModule,
        NgTemplateOutlet
    ],
    templateUrl: './business-process-index-tab.component.html',
    styleUrl: './business-process-index-tab.component.scss'
})
export class BusinessProcessIndexTabComponent implements OnInit {
    @Input() currentMember: MemberModel;

    tab = 0;

    allGroups: BoardGroupModel[];
    allBoards: BoardTableModel[];

    constructor(
        private taskService: TaskServiceService,
    ) {
    }

    ngOnInit(): void {
        this.getAllBoards();
    }

    getAllBoards(): void {
        this.taskService.getAllBoards(false).then(res => {
            this.allBoards = res.boards;
            this.allGroups = res.groups;
        });
    }
}
